export default class EndLessSpinState {
	constructor(scene, stateMachine) {
		this.stateMachine = stateMachine;
		this.stateObject = scene;
		this.slotControls = scene.slotControls;
		this.spinButton = this.slotControls.slotSpinButton;
		this.autoSpinButton = this.slotControls.slotAutoSpinButton;
	}

	enterFrom(oldState) {
		console.log(this.toString() + ' - Enter From: ' + oldState.toString());
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.add(this.longPressSpin_Click, this);
			this.spinButton.clickEvent.add(this.spin_Click, this);
			this.spinButton.pointerDownEvent.add(this.spin_PointerDown, this);
			this.spinButton.longPointerDownEvent.add(this.spin_LongPointerDown, this);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.add(this.autoSpin_Click, this);
		}
		this.slotControls.setSpinButtonText('STOP');
		this.slotControls.setControlActivity(false, true, false); // activity, spinButtonAcivity, autoSpinButtonAcivity

		console.log(this.toString() + '  - run endless spin');
		this.slotControls.applyBet();
		this.stateObject.runSlotEndLess();
	}

	exitTo(newState) {
		console.log(this.toString() + ' - Exit To: ' + newState.toString());
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.remove(this.longPressSpin_Click);
			this.spinButton.clickEvent.remove(this.spin_Click);
			this.spinButton.pointerDownEvent.remove(this.spin_PointerDown);
			this.spinButton.longPointerDownEvent.remove(this.spin_LongPointerDown);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.remove(this.autoSpin_Click);
		}
	}

	//region input
	spin_PointerDown() {}

	spin_LongPointerDown() {}

	longPressSpin_Click() {
		this.stateObject.stopSlot();
		this.slotControls.setControlActivity(false, false, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
		this.slotControls.setSpinButtonText('SPIN');
	}

	spin_Click() {
		this.stateObject.stopSlot();
		this.slotControls.setControlActivity(false, false, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
		this.slotControls.setSpinButtonText('SPIN');
	}

	autoSpin_Click() {}
	//endregion input

	//region old
	handleInput() {}

	physicsUpdate() {}
	//endregion old

	toString() {
		return 'EndlessSpinState';
	}
}
